import React, {useEffect, useState} from 'react';
import {Card, Table, Badge, Dropdown} from 'react-bootstrap';
import {
    filterReservationList,
    getAReservationDetails,
    updateReservationStatus,
} from '../../../services/OrderService';
import ReservationDetails from './ReservationDetails'; // Import the new component

const svg1 = (
    <svg width='20px' height='20px' viewBox='0 0 24 24' version='1.1'>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <rect x='0' y='0' width='24' height='24'></rect>
            <circle fill='#000000' cx='5' cy='12' r='2'></circle>
            <circle fill='#000000' cx='12' cy='12' r='2'></circle>
            <circle fill='#000000' cx='19' cy='12' r='2'></circle>
        </g>
    </svg>
);

const ReservationList = props => {
    const {reservationList, getUpcomingReservations} = props;
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [filteredList, setFilteredList] = useState([]);
    const [viewDetails, setViewDetails] = useState({});
    const [expandedRows, setExpandedRows] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});
   

    // Map frontend filter values to API status values
    const getApiStatus = filterStatus => {
        const statusMap = {
            booking_confirmed: 'Booking Confirmed',
            booking_cancelled: 'Booking Cancelled',
            booking_pending: 'Pending',
            booking_completed: 'Booking Completed',
        };
        return statusMap[filterStatus] || filterStatus;
    };

    useEffect(() => {
        getUpcomingReservations();
    }, [getUpcomingReservations]);

    // Update filtered list when reservationList changes
    useEffect(() => {
        if (reservationList) {
            if (selectedFilter === 'all') {
                setFilteredList(reservationList);
            } else {
                handleFilterReservation(selectedFilter);
            }
        }
    }, [reservationList]);

    const handleFilterReservation = status => {
        setSelectedFilter(status);

        if (status === 'all') {
            setFilteredList(reservationList);
        } else {
            // First filter locally for immediate UI response
            const filtered = reservationList?.filter(reservation => {
                switch (status) {
                    case 'booking_confirmed':
                        return (
                            reservation.status === 'Booking Confirmed' ||
                            reservation.status === 'booking_confirmed'
                        );
                    case 'Absent':
                        return reservation.status === 'Absent';
                    case 'booking_completed':
                        return (
                            reservation.status === 'Booking Completed' ||
                            reservation.status === 'Order Completed' ||
                            reservation.status === 'booking_completed'
                        );
                    default:
                        return true;
                }
            });

            setFilteredList(filtered || []);

            // Then fetch from API for server-side filtering (optional)
            // Convert frontend status to API status
            const apiStatus = getApiStatus(status);
            filterReservationList(apiStatus)
                .then(res => {
                    if (res && res.data) {
                        setFilteredList(res.data);
                    }
                })
                .catch(err =>
                    console.error('Error filtering reservation list:', err)
                );
        }
    };

    // Use filteredList for rendering, fall back to reservationList only if no filter is applied
    const displayList =
        selectedFilter === 'all'
            ? filteredList.length > 0
                ? filteredList
                : reservationList
            : filteredList;

    const handleUpdateReservationStatus = async (bookid, is_completed) => {
        try {
            const res = await updateReservationStatus({bookid, is_completed});
            if (res) {
                getUpcomingReservations();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const ViewDetails = bookid => {
        // If row is already expanded, close it
        if (expandedRows[bookid]) {
            setExpandedRows(prev => ({
                ...prev,
                [bookid]: false,
            }));
            return;
        }

        // If details already exist, just expand
        if (viewDetails[bookid]) {
            setExpandedRows(prev => ({
                ...prev,
                [bookid]: true,
            }));
            return;
        }

        // Set loading state
        setLoadingDetails(prev => ({
            ...prev,
            [bookid]: true,
        }));

        // Fetch details from API
        getAReservationDetails(bookid)
            .then(res => {
                if (res) {
                    setViewDetails(prev => ({
                        ...prev,
                        [bookid]: res[0], // Take first item from data array
                    }));
                    setExpandedRows(prev => ({
                        ...prev,
                        [bookid]: true,
                    }));
                } else {
                    console.warn('No data received for reservation:', bookid);
                    setExpandedRows(prev => ({
                        ...prev,
                        [bookid]: true,
                    }));
                }
            })
            .catch(err => {
                console.error('Error getting reservation details:', err);
                setExpandedRows(prev => ({
                    ...prev,
                    [bookid]: true,
                }));
            })
            .finally(() => {
                setLoadingDetails(prev => ({
                    ...prev,
                    [bookid]: false,
                }));
            });
    };

    const closeDetails = bookid => {
        setExpandedRows(prev => ({
            ...prev,
            [bookid]: false,
        }));
    };

    // const handlePageChange = pageNum => {
    //     setCurrentPage(pageNum);
    // };

    // const handlePageItemsChange = items => {
    //     setPageItems(items);
    //     setCurrentPage(1); // Reset to first page when changing items per page
    // };

    return (
        <>
            <div className='d-sm-flex mb-lg-4 mb-2'>
                {/* <Dropdown className='dropdown mb-2 ml-auto mr-3'>
                    <Dropdown.Toggle
                        to='#'
                        className='i-false btn btn-primary btn-rounded light'
                        data-toggle='dropdown'
                        aria-expanded='false'
                    >
                        <i className='las la-bolt scale5 mr-3' />
                        {selectedFilter === 'all'
                            ? 'All Status'
                            : selectedFilter === 'booking_confirmed'
                            ? 'Booking Confirmed'
                            : selectedFilter === 'Absent'
                            ? 'Absent'
                            : selectedFilter === 'booking_completed'
                            ? 'Booking Completed'
                            : 'All Status'}
                        <i className='las la-angle-down ml-3' />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='dropdown-menu dropdown-menu-center'>
                        <Dropdown.Item
                            className='dropdown-item'
                            to='#'
                            onClick={() => handleFilterReservation('all')}
                        >
                            <span className='text-primary'>All Status</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            to='#'
                            onClick={() =>
                                handleFilterReservation('booking_confirmed')
                            }
                        >
                            <span className='text-primary'>
                                Booking Confirmed
                            </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            to='#'
                            onClick={() => handleFilterReservation('Absent')}
                        >
                            <span className='text-mute'>Absent</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            to='#'
                            onClick={() =>
                                handleFilterReservation('booking_completed')
                            }
                        >
                            <span className='text-success'>
                                Booking Completed
                            </span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown> */}
            </div>

            <Card>
                <Card.Header>
                    <Card.Title>Live Reservation Orders</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table>
                        <thead>
                            <tr>
                                <th>
                                    <strong>RES. NO.</strong>
                                </th>
                                <th>
                                    <strong>DATE</strong>
                                </th>
                                <th>
                                    <strong>CUSTOMER</strong>
                                </th>
                                <th>
                                    <strong>TABLE NO.</strong>
                                </th>
                                <th>
                                    <strong>NO. OF GUESTS</strong>
                                </th>
                                <th>
                                    <strong>AMOUNT</strong>
                                </th>
                                <th>
                                    <strong>STATUS</strong>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayList ? (
                                displayList.length > 0 ? (
                                    displayList.map(each => (
                                        <React.Fragment key={each.bookid}>
                                            <tr>
                                                <td>
                                                    <strong>
                                                        {each.bookid}
                                                    </strong>
                                                </td>
                                                <td>
                                                    {each.date +
                                                        ' ' +
                                                        each.time.slice(0, -7)}
                                                </td>
                                                <td>{each.initiator}</td>
                                                <td>{each.table_no}</td>
                                                <td>{each.n_o_g}</td>
                                                <td>SAR {each.total}</td>
                                                <td>
                                                    <Badge
                                                        variant={
                                                            each.status ===
                                                            'Booking Confirmed'
                                                                ? 'success'
                                                                : each.status ===
                                                                  'Order Completed'
                                                                ? 'success light'
                                                                : each.status ===
                                                                  'Booking Pending'
                                                                ? 'warning '
                                                                : 'dark text-white '
                                                        }
                                                    >
                                                        {each.status}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant={
                                                                each.status ===
                                                                'Booking Confirmed'
                                                                    ? 'success'
                                                                    : each.status ===
                                                                      'Order Completed'
                                                                    ? 'success light'
                                                                    : each.status ===
                                                                      'Booking Pending'
                                                                    ? 'warning '
                                                                    : 'dark text-white '
                                                            }
                                                            className='light sharp i-false'
                                                        >
                                                            {svg1}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu className='dropdown-menu dropdown-menu-right'>
                                                            {each.status.toLowerCase() ==
                                                                'booking confirmed' && (
                                                                <>
                                                                    <Dropdown.Item
                                                                        onClick={() =>
                                                                            handleUpdateReservationStatus(
                                                                                each.bookid,
                                                                                true
                                                                            )
                                                                        }
                                                                        className='dropdown-item'
                                                                    >
                                                                        <i className='las la-check-circle text-success mr-3 scale5' />
                                                                        Confirm
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Item
                                                                        onClick={() =>
                                                                            handleUpdateReservationStatus(
                                                                                each.bookid,
                                                                                false
                                                                            )
                                                                        }
                                                                        className='dropdown-item'
                                                                    >
                                                                        <i className='las la-times-circle text-danger mr-3 scale5' />
                                                                        Reject
                                                                    </Dropdown.Item>
                                                                </>
                                                            )}

                                                            <Dropdown.Item
                                                                onClick={() =>
                                                                    ViewDetails(
                                                                        each.bookid
                                                                    )
                                                                }
                                                                className='dropdown-item'
                                                            >
                                                                <i className='las la-eye mr-3 scale5' />
                                                                {loadingDetails[
                                                                    each.bookid
                                                                ]
                                                                    ? 'Loading...'
                                                                    : expandedRows[
                                                                          each
                                                                              .bookid
                                                                      ]
                                                                    ? 'Hide Details'
                                                                    : 'View Details'}
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                            {expandedRows[each.bookid] && (
                                                <ReservationDetails
                                                    reservationDetails={
                                                        viewDetails[each.bookid]
                                                    }
                                                    isLoading={
                                                        loadingDetails[
                                                            each.bookid
                                                        ]
                                                    }
                                                    onClose={closeDetails}
                                                    bookingId={each.bookid}
                                                />
                                            )}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan='8'
                                            className='text-center py-4'
                                        >
                                            <div className='d-flex flex-column align-items-center'>
                                                <p className='text-muted'>
                                                    No reservations
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <td colSpan='8'>
                                        <div id='preloader-inner'>
                                            <div className='sk-three-bounce-inner'>
                                                <div className='sk-child sk-bounce1'></div>
                                                <div className='sk-child sk-bounce2'></div>
                                                <div className='sk-child sk-bounce3'></div>
                                                <div id='preloader-inner-bg'></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
                {/* <Card.Footer>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Pagination>
                            <Pagination.First
                                disabled={pagination.currentPage === 1}
                                onClick={() => handlePageChange(1)}
                            />
                            <Pagination.Prev
                                disabled={pagination.currentPage === 1}
                                onClick={() =>
                                    handlePageChange(pagination.currentPage - 1)
                                }
                            />
                            {[...Array(pagination.totalPages)].map((_, i) => {
                                const pageNum = i + 1;
                                if (
                                    pageNum === 1 ||
                                    pageNum === pagination.totalPages ||
                                    (pageNum >= pagination.currentPage - 1 &&
                                        pageNum <= pagination.currentPage + 1)
                                ) {
                                    return (
                                        <Pagination.Item
                                            key={pageNum}
                                            active={
                                                pageNum ===
                                                pagination.currentPage
                                            }
                                            onClick={() =>
                                                handlePageChange(pageNum)
                                            }
                                        >
                                            {pageNum}
                                        </Pagination.Item>
                                    );
                                }
                                if (
                                    (pageNum === 2 &&
                                        pagination.currentPage > 3) ||
                                    (pageNum === pagination.totalPages - 1 &&
                                        pagination.currentPage <
                                            pagination.totalPages - 2)
                                ) {
                                    return (
                                        <Pagination.Ellipsis
                                            key={`ellipsis-${pageNum}`}
                                        />
                                    );
                                }
                                return null;
                            })}
                            <Pagination.Next
                                disabled={
                                    pagination.currentPage ===
                                    pagination.totalPages
                                }
                                onClick={() =>
                                    handlePageChange(pagination.currentPage + 1)
                                }
                            />
                            <Pagination.Last
                                disabled={
                                    pagination.currentPage ===
                                    pagination.totalPages
                                }
                                onClick={() =>
                                    handlePageChange(pagination.totalPages)
                                }
                            />
                        </Pagination>
                        <div className='d-flex align-items-center'>
                            <span className='mr-2'>Items per page:</span>
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant='outline-primary'
                                    size='sm'
                                >
                                    {pageItems}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() => handlePageItemsChange(5)}
                                    >
                                        5
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() =>
                                            handlePageItemsChange(10)
                                        }
                                    >
                                        10
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() =>
                                            handlePageItemsChange(20)
                                        }
                                    >
                                        20
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() =>
                                            handlePageItemsChange(50)
                                        }
                                    >
                                        50
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </Card.Footer> */}
            </Card>
        </>
    );
};

export default ReservationList;
